import store from '@/store';
import { GPS_STATUS } from '@/util/dictList';
export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: "主键id",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "进件编号",
      prop: "businessCode",
      type: "input",
      search: true,
      searchOrder: 993,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      type: "input",
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      dicData: store.getters.porductTypes
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      search: true,
      searchOrder: 999,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      dicData: store.getters.porductTypes
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: true,
      searchOrder: 998,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      type: "input",
      search: true,
      searchOrder: 997,
    },
    {
      label: "租赁金额",
      prop: "lendingAmount",
      type: "input",
    },
    {
      label: "每月租金",
      prop: "lendingAmountPer",
      type: "input",
    },
    {
      label: "无线206Dw状态",
      prop: "wirelessGpsStatus",
      hide: true,
      showColumn: false,
      search: true,
      type: "select",
      searchLabelWidth: 120,
      searchOrder: 996,
      dicData: GPS_STATUS,
    },
    {
      label: "无线206Dw状态",
      prop: "wirelessGpsStatusString",
      type: "select",
      formatter: (val, value) => {
        return value ? value : '未提交';
      },
    },
    {
      label: "有线E3状态",
      prop: "wireGpsStatus",
      hide: true,
      showColumn: false,
      search: true,
      type: "select",
      searchLabelWidth: 120,
      searchOrder: 996,
      dicData: GPS_STATUS,
    },
    {
      label: "有线E3状态",
      prop: "wireGpsStatusString",
      type: "select",
      formatter: (val, value) => {
        return value ? value : '未提交';
      },
    },
    {
      label: "无线G50状态",
      prop: "wirelessGpsTwoStatus",
      hide: true,
      showColumn: false,
      search: true,
      type: "select",
      searchLabelWidth: 120,
      searchOrder: 996,
      dicData: GPS_STATUS,
    },
    {
      label: "无线G50状态",
      prop: "wirelessGpsTwoStatusString",
      type: "select",
      formatter: (val, value) => {
        return value ? value : '未提交';
      },
    },
    {
      label: "防水mini状态",
      prop: "miniGpsStatus",
      hide: true,
      showColumn: false,
      search: true,
      type: "select",
      searchLabelWidth: 120,
      searchOrder: 996,
      dicData: GPS_STATUS,
    },
    {
      label: "防水mini状态",
      prop: "miniGpsStatusString",
      type: "select",
      formatter: (val, value) => {
        return value ? value : '未提交';
      },
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
  ],
};
